import { gql } from '@apollo/client';

export const CREATE_TAG_MUTATION = gql`
  mutation createTag($name: String!) {
    createTag(name: $name) {
      tag {
        id
        currentVersion {
          id
          name
        }
      }
    }
  }
`;

export const ADD_TAG_VERSION_MUTATION = gql`
  mutation addVersionToTag(
    $tagId: Int!
    $name: String!
    $publish: Boolean
  ) {
    addVersionToTag(tagId: $tagId, name: $name, publish: $publish) {
      tagVersion {
        id
        name
      }
    }
  }
`;

export const EDIT_TAG_VERSION_MUTATION = gql`
  mutation editDraftTagVersion(
    $tagId: Int!
    $name: String!
  ) {
    editDraftTagVersion(tagId: $tagId, name: $name) {
      tagVersion {
        id
        name
        status
        version
      }
    }
  }
`;
